import React from 'react';
import { getNextgenSettingsUrl } from '@jira/project-settings__get-settings-url/src/getClassicIssueLayoutSettingsUrl.tsx';
import { SERVICE_DESK_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';

export type AutomationPageType = 'summary' | 'edit' | 'copy' | 'create' | 'viewlog';

// uses empty string instead of actual baseUrl as router redirect handles it internally
const newAutomationUrl = ({ match }: RouteContext, pageType: AutomationPageType) => {
	const { projectKey } = match.params;
	if (pageType === 'edit') {
		const { ruleId } = match.params;
		return `${getNextgenSettingsUrl(SERVICE_DESK_PROJECT, String(projectKey))}/automation/ruleset/${ruleId || ''}`;
	}
	if (pageType === 'copy') {
		const { ruleId } = match.params;
		return `${getNextgenSettingsUrl(SERVICE_DESK_PROJECT, String(projectKey))}/automation/copy/${ruleId || ''}`;
	}
	if (pageType === 'viewlog') {
		const { ruleId } = match.params;
		return `${getNextgenSettingsUrl(SERVICE_DESK_PROJECT, String(projectKey))}/automation/log/${ruleId || ''}`;
	}
	if (pageType === 'create') {
		const { blueprintKey } = match.params;
		return `${getNextgenSettingsUrl(SERVICE_DESK_PROJECT, String(projectKey))}/automation/blueprint/${blueprintKey || ''}`;
	}
	return `${getNextgenSettingsUrl(SERVICE_DESK_PROJECT, String(projectKey))}/automation`;
};

/**
 * Higher order component that generates a redirect to a specific route
 * These redirects to not push to history
 *
 * Currently this is used to redirect existing routes to the new automation routes
 */
export const automationRedirect =
	(pageType: AutomationPageType) =>
	(routeContext: RouteContext): React.JSX.Element => {
		return <Redirect to={newAutomationUrl(routeContext, pageType)} push={false} />;
	};
